import { YNFLoader } from 'ynf-core-loader';
import React from 'react'
import { withObserver } from '../connector'
import parseNode from '../common/parseNode'

const reactiveReg = /^mobx:\/\//
const YNFLoaderObserver = withObserver(YNFLoader)
function renderChildren (children, { rootStore, rowStore, parent }) {
  if (!children?.length) return null
  const childrenParsed = []
  children.forEach(child => {
    const childParsed = render(child, { rootStore, rowStore, parent })
    if (Array.isArray(childParsed)) {
      childrenParsed.push(...childParsed)
    } else {
      childrenParsed.push(childParsed)
    }
  })
  return childrenParsed
}

function getFieldPrefix(alias, rootStore, rowStore){
  const order = rowStore?.order || "";
  return `${rootStore?.pageStore?.params?.billNo}|${alias}${order? '|' + order : ''}`
}

let metaObject;
export default function render (meta, options = {}) {
  if (!meta) return null
  if (Array.isArray(meta)) {
    return meta.map(child => {
      return render(child, options)
    })
  }

  const { rootStore, rowStore, parent, ...extraProps } = options
  const { libCode, compType, controlType, children, alias, store } = meta
  const parsedProps = parseNode(meta, { markUsed: false, rootStore, rowStore })
  let Indeterminate = YNFLoader
  // tabs会读到mobxObserver组件
  let key = alias
  let caption = meta.caption
  if (reactiveReg.test(key)) {
    try {
      // eslint-disable-next-line
      key = eval(key.replace(reactiveReg, ''))
      // eslint-disable-next-line
      caption = eval(caption.replace(reactiveReg, ''))
    } catch (e) {
    }
  }
  // TODO 覆盖逻辑顺序
  const mergedProps = {
    key,
    caption,
    fieldidPrefix: getFieldPrefix(alias, rootStore, rowStore),
    rowStore,
    ...parsedProps?.normal,
    ...extraProps
  }
  if (meta.cStyleSplit) {
    mergedProps.cStyle = {}
  }
  if (parsedProps?.reactive && Object.keys(parsedProps?.reactive).length) {
    Indeterminate = YNFLoaderObserver
    Object.assign(mergedProps, {
      getProps2Observe: () => {
        const object = {}
        Object.keys(parsedProps.reactive).forEach(key => {
          try {
            // eslint-disable-next-line
            object[key] = eval(parsedProps.reactive[key])
          } catch (error) {
          }
        })
        return object
      }
    })
  }

  // 容器类组件，将子的meta协议传到组件的$children里，供组件读取子的meta使用
  if (compType === 'xcontainer' && children) {
    mergedProps.$children = children
  }

  if (controlType === 'BillTemplate') {
    metaObject = { ...meta }
    Object.freeze(metaObject);
  } else {
    mergedProps.meta = metaObject
  }

  // BillTemplate类似组件只渲染children
  if (
    !controlType ||
    !libCode
  ) {
    if (children?.length) {
      return renderChildren(children, { rootStore, parent: meta, rowStore })
    }
    return null
  }

  const getChildren = () => {
    if (extraProps?.children) {
      return extraProps?.children
    }
    if (
      !/(Table|WaterfallList|Form|ConvenientQuery|ApproveOpinionContainer)/.test(meta.controlType) &&
      meta.parseChildren !== false
    ) {
      return renderChildren(children, { rootStore, rowStore, parent: meta })
    }
    return null
  }

  // 获取JSONSchema 可以采用该方案进行store与组件解耦
  const subStore = mergedProps.getProps2Observe?.()?.store
  const JSONSchema = subStore?.getJSONSchema?.(controlType.toLocaleLowerCase())
  if (JSONSchema) mergedProps.JSONSchema = JSONSchema

  return (
    <Indeterminate
      providerPackage={libCode}
      providerEntry={controlType}
      context={rootStore?.context}
      {...mergedProps}
    >
      {
        getChildren()
      }
    </Indeterminate>
  )
}
